<template>
  <div class="manual-input">

    <!-- authors -->
    <template v-if="keyname=='authors'">
      <input-vuetify-form
        category="authors"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.author')"
        :isrequired="isrequired"
        :complete.sync="new_complete">
      </input-vuetify-form>
    </template>

    <!-- reporters -->
    <template v-if="keyname=='reporters'">
      <input-vuetify-form
        category="authors"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.reporter')"
        :isrequired="isrequired"
        :complete.sync="new_complete">
      </input-vuetify-form>
    </template>

    <!-- creators -->
    <template v-if="keyname=='creators'">
      <input-vuetify-form
        category="authors"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.creator')"
        :isrequired="isrequired"
        :complete.sync="new_complete">
      </input-vuetify-form>
    </template>

    <!-- directors -->
    <template v-if="keyname=='directors'">
      <input-vuetify-form
        category="authors"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.director')"
        :isrequired="isrequired"
        :complete.sync="new_complete">
      </input-vuetify-form>
    </template>

    <!-- makers -->
    <template v-if="keyname=='makers'">
      <input-vuetify-form
        category="authors"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.maker')"
        :isrequired="isrequired"
        :complete.sync="new_complete">
      </input-vuetify-form>
    </template>

    <!-- date -->
    <template v-if="keyname=='date'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.date')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- statistics_date -->
    <template v-if="keyname=='statistics_date'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.date')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- address_date -->
    <template v-if="keyname=='address_date'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.date')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- publishing_date -->
    <template v-if="keyname=='publishing_date'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.publishing_date')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- conference_dates -->
    <template v-if="keyname=='conference_dates'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.conference_dates')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- year -->
    <template v-if="keyname=='year'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.year')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>


    <!-- title -->
    <template v-if="keyname=='title'">
      <input-vuetify-form
        category="text-loading"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.title')"
        :isrequired="isrequired"
        :query="query"
        :document.sync="new_document">
      </input-vuetify-form>
    </template>

    <!-- law_title -->
    <template v-if="keyname=='law_title'">
      <input-vuetify-form
        category="text-loading"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.law_title')"
        :isrequired="isrequired"
        :query="query"
        :document.sync="new_document">
      </input-vuetify-form>
    </template>

    <!-- statistics_title -->
    <template v-if="keyname=='statistics_title'">
      <input-vuetify-form
        category="text-loading"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.statistics_title')"
        :isrequired="isrequired"
        :query="query"
        :document.sync="new_document">
      </input-vuetify-form>
    </template>

    <!-- issue_title -->
    <template v-if="keyname=='issue_title'">
      <input-vuetify-form
        category="text-loading"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.issue_title')"
        :isrequired="isrequired"
        :query="query"
        :document.sync="new_document">
      </input-vuetify-form>
    </template>

    <!-- article_title -->
    <template v-if="keyname=='article_title'">
      <input-vuetify-form
        category="text-loading"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.article_title')"
        :isrequired="isrequired"
        :query="query"
        :document.sync="new_document">
      </input-vuetify-form>
    </template>

    <!-- album_name -->
    <template v-if="keyname=='album_name'">
      <input-vuetify-form
        category="text-loading"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.album_title')"
        :isrequired="isrequired"
        :query="query"
        :document.sync="new_document">
      </input-vuetify-form>
    </template>

    <!-- film_title -->
    <template v-if="keyname=='film_title'">
      <input-vuetify-form
        category="text-loading"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.film_title')"
        :isrequired="isrequired"
        :query="query"
        :document.sync="new_document">
      </input-vuetify-form>
    </template>

    <!-- chapter_title -->
    <template v-if="keyname=='chapter_title'">
      <input-vuetify-form
        category="text-loading"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.chapter_title')"
        :isrequired="isrequired"
        :query="query"
        :document.sync="new_document">
      </input-vuetify-form>
    </template>

    <!-- table_title -->
    <template v-if="keyname=='table_title'">
      <input-vuetify-form
        category="text-loading"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.table_title')"
        :isrequired="isrequired"
        :query="query"
        :document.sync="new_document">
      </input-vuetify-form>
    </template>

    <!-- music_title -->
    <template v-if="keyname=='music_title'">
      <input-vuetify-form
        category="text-loading"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.music_title')"
        :isrequired="isrequired"
        :query="query"
        :document.sync="new_document">
      </input-vuetify-form>
    </template>

    <!-- episode_title -->
    <template v-if="keyname=='episode_title'">
      <input-vuetify-form
        category="text-loading"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.episode_title')"
        :isrequired="isrequired"
        :query="query"
        :document.sync="new_document">
      </input-vuetify-form>
    </template>

    <!-- sub_title -->
    <template v-if="keyname=='sub_title'">
      <input-vuetify-form
        category="text-loading"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.subtitle')"
        :isrequired="isrequired"
        :query="query"
        :document.sync="new_document">
      </input-vuetify-form>
    </template>


    <!-- language -->
    <template v-if="keyname=='lang'">
      <input-vuetify-form
        category="select"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.language')"
        :model="language_model"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>


    <!-- contents -->
    <template v-if="keyname=='contents'">
      <input-vuetify-form
        category="textarea"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.contents')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- description -->
    <template v-if="keyname=='description'">
      <input-vuetify-form
        category="textarea"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.description')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- abstract -->
    <template v-if="keyname=='abstract'">
      <input-vuetify-form
        category="textarea"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.abstract')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- keywords -->
    <template v-if="keyname=='keywords'">
      <input-vuetify-form
        category="multiple"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.keyword')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- DOI -->
    <template v-if="keyname=='DOI'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.doi')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- DOI_chapter -->
    <template v-if="keyname=='DOI_chapter'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.chapter_doi')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- DOI_article -->
    <template v-if="keyname=='DOI_article'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.article_doi')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- DOI_paper -->
    <template v-if="keyname=='DOI_paper'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.paper_doi')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- DOI_book -->
    <template v-if="keyname=='DOI_book'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.book_doi')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- DOI_thesis -->
    <template v-if="keyname=='DOI_thesis'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.thesis_doi')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- DOI_document -->
    <template v-if="keyname=='DOI_document'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.document_doi')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- DOI_proceeding -->
    <template v-if="keyname=='DOI_proceeding'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.proceeding_doi')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- DOI_publication -->
    <template v-if="keyname=='DOI_publication'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.publication_doi')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- URL -->
    <template v-if="keyname=='URL'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.url')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- URL_chapter -->
    <template v-if="keyname=='URL_chapter'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.chapter_url')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- URL_article -->
    <template v-if="keyname=='URL_article'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.article_url')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- URL_table -->
    <template v-if="keyname=='URL_table'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.table_url')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- URL_music -->
    <template v-if="keyname=='URL_music'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.music_url')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- URL_episode -->
    <template v-if="keyname=='URL_episode'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.episode_url')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- URL_map -->
    <template v-if="keyname=='URL_map'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.map_url')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- URL_book -->
    <template v-if="keyname=='URL_book'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.book_url')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- URL_thesis -->
    <template v-if="keyname=='URL_thesis'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.thesis_url')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- URL_report -->
    <template v-if="keyname=='URL_report'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.report_url')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- URL_law -->
    <template v-if="keyname=='URL_law'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.law_url')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- URL_statistics -->
    <template v-if="keyname=='URL_statistics'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.statistics_url')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- URL_journal -->
    <template v-if="keyname=='URL_journal'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.journal_url')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- URL_conference -->
    <template v-if="keyname=='URL_conference'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.conference_url')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- URL_newspaper -->
    <template v-if="keyname=='URL_newspaper'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.newspaper_url')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- URL_magazine -->
    <template v-if="keyname=='URL_magazine'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.magazine_url')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- URL_album -->
    <template v-if="keyname=='URL_album'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.album_url')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- URL_film -->
    <template v-if="keyname=='URL_film'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.film_url')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- URL_publication -->
    <template v-if="keyname=='URL_publication'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.publication_url')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- journal_name -->
    <template v-if="keyname=='journal_name'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.journal_name')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- conference_name -->
    <template v-if="keyname=='conference_name'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.conference_name')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- newspaper_name -->
    <template v-if="keyname=='newspaper_name'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.newspaper_name')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- magazine_name -->
    <template v-if="keyname=='magazine_name'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.magazine_name')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- book_title -->
    <template v-if="keyname=='book_title'">
      <input-vuetify-form
        category="text-loading"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.book_title')"
        :isrequired="isrequired"
        :query="query"
        :document.sync="new_document">
      </input-vuetify-form>
    </template>

    <!-- document_title -->
    <template v-if="keyname=='document_title'">
      <input-vuetify-form
        category="text-loading"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.document_title')"
        :isrequired="isrequired"
        :query="query">
      </input-vuetify-form>
    </template>

    <!-- map_title -->
    <template v-if="keyname=='map_title'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.map_title')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- publication_title -->
    <template v-if="keyname=='publication_title'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.publication_title')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- volume -->
    <template v-if="keyname=='volume'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.volume_issue')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- number -->
    <template v-if="keyname=='number'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.number')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- numberth -->
    <template v-if="keyname=='numberth'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.numberth')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>


    <!-- pages -->
    <template v-if="keyname=='pages'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.pages')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- episode_number -->
    <template v-if="keyname=='episode_number'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.episode_number')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- edition -->
    <template v-if="keyname=='edition'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.edition')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- diplome_title -->
    <template v-if="keyname=='diplome_title'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.diplome_title')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- document_category -->
    <template v-if="keyname=='document_category'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.document_category')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- version -->
    <template v-if="keyname=='version'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.version')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- provisional_confirmed -->
    <template v-if="keyname=='provisional_confirmed'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.provisional_confirmed')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- session -->
    <template v-if="keyname=='session'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.session')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- morning_afternoon -->
    <template v-if="keyname=='morning_afternoon'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.morning_afternoon')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- map_size -->
    <template v-if="keyname=='map_size'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.map_size')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>


    <!-- publisher -->
    <template v-if="keyname=='publisher'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.publisher')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- university -->
    <template v-if="keyname=='university'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.university')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- institution -->
    <template v-if="keyname=='institution'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.institution')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- company -->
    <template v-if="keyname=='company'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.company')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- label -->
    <template v-if="keyname=='label'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.label')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- production -->
    <template v-if="keyname=='production'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.production')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>


    <!-- OCLC -->
    <template v-if="keyname=='OCLC'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.oclc')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>


    <!-- ISBN -->
    <template v-if="keyname=='ISBN'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.isbn')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>


    <!-- ISSN -->
    <template v-if="keyname=='ISSN'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.issn')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>


    <!-- editors -->
    <template v-if="keyname=='editors'">
      <input-vuetify-form
        category="authors"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.editor')"
        :isrequired="isrequired"
        :complete.sync="new_complete">
      </input-vuetify-form>
    </template>

    <!-- juries -->
    <template v-if="keyname=='juries'">
      <input-vuetify-form
        category="authors"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.jury')"
        :isrequired="isrequired"
        :complete.sync="new_complete">
      </input-vuetify-form>
    </template>


    <!-- translators -->
    <template v-if="keyname=='translators'">
      <input-vuetify-form
        category="authors"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.translator')"
        :isrequired="isrequired"
        :complete.sync="new_complete">
      </input-vuetify-form>
    </template>


    <!-- paper_ebook -->
    <template v-if="keyname=='paper_ebook'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.paper_ebook')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- department -->
    <template v-if="keyname=='department'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.department')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- law_category -->
    <template v-if="keyname=='law_category'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.law_category')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- paper_online -->
    <template v-if="keyname=='paper_online'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.online_paper')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- Place -->
    <template v-if="keyname=='place'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.place')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- dvd_online -->
    <template v-if="keyname=='dvd_online'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.dvd_online')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- Note -->
    <template v-if="keyname=='note'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.note')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- other_idf -->
    <template v-if="keyname=='other_idf'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.other_idf')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

    <!-- paper_digital -->
    <template v-if="keyname=='paper_digital'">
      <input-vuetify-form
        category="text"
        :data.sync="new_data"
        :keyname="keyname"
        :name="$t('input_form.digital_paper')"
        :isrequired="isrequired">
      </input-vuetify-form>
    </template>

  </div>
</template>

<script>
import { languages } from '../../../custom/model'

export default {
  props: {
    data: {
      required: true,
    },

    keyname: {
      type: String,
    },

    isrequired: {
      type: Boolean,
    },

    complete: {
      type: Boolean,
    },

    query: {
      type: Object,
    },

    document: {
      type: Object,
    },
  },

  data() {
    return {
      languages: languages,
      language_model: null,

      new_data: this.data,
      new_complete: this.complete,
      new_document: this.document,
    }
  },

  created() {
    if (!!this.languages) {
      let vm = this
      let keys = Object.keys(this.languages)
      keys.forEach(v => {
        vm.languages[v].name = vm.$t('lang.'+ v)
      })
      this.language_model = this.languages
    }
  },

  // watch: {
  //   languages: {
  //     handler(val) {
  //       if (!!val) {
  //         let vm = this
  //         let keys = Object.keys(this.languages)
  //         keys.forEach(v => {
  //           vm.languages[v].name = vm.$t('lang.'+ vm.languages[v].key)
  //           console.log(vm.languages[v].name, vm.languages[v].key)
  //         })
  //         this.language_model = this.languages
  //       }
  //     },
  //     immediate: true,
  //   }
  // },

  // computed: {
  //   language_model() {
  //     let vm = this
  //     let keys = Object.keys(this.languages)
  //     keys.forEach(v => {
  //       vm.languages[v].name = vm.$t('lang.'+ vm.languages[v].key)
  //       console.log(vm.languages[v].name, vm.languages[v].key)
  //     })
  //     return this.languages
  //   }
  // },

  watch: {
    new_data: {
      handler(val) {
        this.$emit('update:data', this.new_data)
      },
    },

    new_complete: {
      handler(val) {
        this.$emit('update:complete', this.new_complete)
      },
    },

    new_document: {
      handler(val) {
        this.$emit('update:document', this.new_document)
      },
      deep: true,
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/shared_components/form/ManualInput.vue